import { createFileRoute } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { AccountDetailPage } from '@/pages/admin/accounts/AccountDetailPage';
import { accountKeys } from '@/pages/admin/api/queries/useAccounts';
import { apiClient } from '@/api/client';
import { notFoundOrUnknownKey } from '@/api/errors';
import { listAccountsContract, type ListAccountsResponse } from '@bliks-io/contracts';
import i18next from '@/lib/i18n';

export const Route = createFileRoute('/admin/accounts/$accountId/')({
  loader: async ({
    params,
    context
  }: {
    params: { accountId: string };
    context: { queryClient: QueryClient };
  }) => {
    try {
      const data = await context.queryClient.ensureQueryData({
        queryKey: accountKeys.list(),
        queryFn: async (): Promise<ListAccountsResponse> => {
          const { data } = await apiClient.get<ListAccountsResponse>(listAccountsContract.path);
          return data;
        }
      });

      const account = data.accounts.find((a) => a._id === params.accountId);

      return { breadcrumb: account?.name ?? i18next.t('errors.account.notFound') };
    } catch (error) {
      return { breadcrumb: i18next.t(notFoundOrUnknownKey(error, 'errors.account.notFound')) };
    }
  },
  component: AccountDetailPage
});
